import { compose, withProps } from 'recompose';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { isEmpty } from 'utils/types';

import { selectors as orderSelectors, selectorsByType } from 'state/order';
import { selectors as authSelectors } from 'state/auth';

import DiffPriceWhenEdit from 'components/Price/DiffPriceWhenEdit/styled';

const enhance = compose(
  withTranslation('Quote'),
  connect((state, { typeOfOrder }) => {
    const orderType = typeOfOrder || orderSelectors.getTypeOfOrder(state);

    return {
      quote: selectorsByType.quote[orderType].getQuote(state),
      isEditing: orderSelectors.getIsEditing(state),
      originalPrice: orderSelectors.getOriginalPrice(state),
      paymentMethod: authSelectors.getUserPaymentMethod(state),
      diff: orderSelectors.getDiffPriceWhenEdit(state),
    };
  }, {}),
  withProps(({ quote, isEditing, originalPrice, paymentMethod, diff }) => {
    let isDataReady = !isEmpty(quote) && !isEmpty(originalPrice);

    let label = 'diff_price_when_edit';

    if (diff !== 0) {
      if (paymentMethod === 'CARD') {
        label = `${label}.CARD`;
      }
      label = `${label}.${diff > 0 ? 'positive' : 'negative'}`;
    } else {
      isDataReady = true;
      label = `${label}.no`;
    }

    return {
      originalTotalPrice: Number(originalPrice.net_full_price),
      diff,
      hasToShowDiffPriceWhenEdit: isEditing && isDataReady,
      label: isEditing && isDataReady ? label : '',
    };
  })
);

export default enhance(DiffPriceWhenEdit);
